import { isBlackNovember } from 'shared/presentation/helpers';

import { blackNovemberPalette } from './blackNovemberPalette';
import { darkPalette } from './darkPalette';
import { layout } from './layout';
import { lightPalette } from './lightPalette';
import { pinkOctoberPalette } from './pinkOctoberPalette';
import { typography } from './typography';
import { ITheme } from '../models/ITheme';

const palettes = {
  light: lightPalette,
  dark: darkPalette,
  pinkOctober: pinkOctoberPalette,
  blackNovember: blackNovemberPalette,
};

export const blackNovemberTheme: ITheme = {
  name: 'dark',
  typography,
  layout,
  palette: palettes.blackNovember,
};

export const lightTheme: ITheme = {
  name: 'light',
  typography,
  layout,
  palette: palettes.light,
};

export const theme = getDefaultTheme();

function getDefaultTheme() {
  if (isBlackNovember()) return blackNovemberTheme;

  return lightTheme;
}
